module.exports = __webpack_public_path__ + "img/kajak4.8bd36bc9.jpg";